const MIN_PURE_SEQUENCE = 3
const MIN_EMBEDDED_SEQUENCE = 6

const compactValue = (value: string) =>
  value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')

const longestStepRun = (run: string) => {
  let longest = 1
  let ascending = 1
  let descending = 1

  for (let index = 1; index < run.length; index += 1) {
    const diff = run.charCodeAt(index) - run.charCodeAt(index - 1)
    ascending = diff === 1 ? ascending + 1 : 1
    descending = diff === -1 ? descending + 1 : 1
    longest = Math.max(longest, ascending, descending)
  }

  return longest
}

export const hasSequentialChars = (value: string) => {
  const compact = compactValue(value)

  if (!compact) {
    return false
  }

  const pureSequence = /^[a-z]+$/.test(compact) || /^\d+$/.test(compact)

  if (pureSequence && compact.length >= MIN_PURE_SEQUENCE && longestStepRun(compact) === compact.length) {
    return true
  }

  const runs = compact.match(/[a-z]+|\d+/g) ?? []

  return runs.some((run) => longestStepRun(run) >= MIN_EMBEDDED_SEQUENCE)
}
